"use client";

import { usePathname } from "next/navigation";
import styles from "./BannerWithImageNew.module.scss";
import cn from "clsx";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";
import Markdown from "@/components/atoms/Markdown";
import CommonButton from "@/components/common/Analytics/CustomButton";
import { GAEvent, GA_EVENTS, GA_EVENTS_PAYLOAD, IGAEvent, ga_events_mapping } from "@/helpers/gaEvents";
import { useEffect, useState, useRef, useContext } from "react";
import { StorageService } from "@/helpers/storage.service";
import { ModalTypes,IModalActions } from "@/types/modal";
import {
  OTPContext,
  OTPContextProvider,
  OTPContextWrapper,
} from "@/components/sections/CommonModals/context";
import ProgramDetailsConnectModalForm from "../Forms/ProgramPageConnectModalForm/ProgramPageConnectModalForm";
import ImageTag from "./TagView/ImageTag";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import { pushToDataLayer } from "@/helpers/gtag";
import { title } from "process";
import {imgPathReplace} from "@/helpers/imgPathReplace";
import shareIcon from "~/icons/share.png"
import { ModalContext } from "@/context/ModalContext";

interface BannerWithImageProps {
  BannerData: any;
  isMobile: boolean;
  fetchPriority?: "auto" | "high";
  specializationText: string;
  Custom10PgType?: string;
  associatedPrograms: Array<ProgramDetails>;
  ProgramId: string;
  NewBannerUI: NewBannerUI;
  isSeatsFilledEnabled: boolean;
  Numbers: number;
  isCampusImmersionPage?: boolean;
}

export default function BannerWithImageNew({
  BannerData,
  isMobile,
  fetchPriority = "auto",
  specializationText,
  Custom10PgType = "",
  associatedPrograms,
  ProgramId,
  NewBannerUI,
  isSeatsFilledEnabled,
  Numbers,
  isCampusImmersionPage =false
}: BannerWithImageProps) {
  const [ leadFailed, setLeadFailed ] = useState(false);
  const { modalDispatch } = useContext(ModalContext);

  const isLeadFailed = (status:boolean)=>{
    setLeadFailed(status)
    }
  const pathName = usePathname();
  const [clickedInsideLeadForm, setClickedInsideLeadForm] = useState(false);

  const {
    PROGRAM_TAB_DOWNLOAD_BROCHURE,
    PROGRAM_CARD_DOWNLOAD_BROCHURE,
    PROGRAM_DOWNLOAD_BROCHURE,
    LEAD_INITIATE
  } = GAEvent;
  const [gaData, setGaData] = useState<IGAEvent | null>(null);
  
  function getGaSessionData(): {
    isMbaPage?: boolean;
    isNavbarClick?: boolean;
  } | null {
    return StorageService.get("programDetailsGAInfo") ?? {};
  }

  useEffect(() => {
    updateStateSession({
      formSectionName : "Download Brochure",
      leadStartingCta : BannerData?.CTA?.text || "NA"
    });
  }, []);


  useEffect(() => {
    try {
      const { isMbaPage = false, isNavbarClick } = getGaSessionData();
      if (ga_events_mapping?.[pathName] || isMbaPage) {
        let data: any;
        if (isNavbarClick !== undefined) {
          data = {
            ...GA_EVENTS_PAYLOAD.get(
              isNavbarClick ? PROGRAM_TAB_DOWNLOAD_BROCHURE : PROGRAM_CARD_DOWNLOAD_BROCHURE
            ),
            pageType: isNavbarClick ? "Program Nav" : "Program Card",
          };
        } else {
          data = {
            ...GA_EVENTS_PAYLOAD.get(PROGRAM_DOWNLOAD_BROCHURE),
            pageType: "Program Details",
          };
        }
        setGaData(data);
      }
    } catch (error) {
      console.error("Error parsing programDetailsGAInfo from sessionStorage", error);
    }
  }, []);


  const handleClickInsideLeadForm = (e) => {
    if (!clickedInsideLeadForm) {
      StorageService.set("timeConnectModal", true)
      
      pushToDataLayer(
        {
          event :	"lead_initiate",
          cta_text : "NA",
          section_name : "hero_banner",
          header_title :	BannerData?.Heading?.text || "NA",
          page_type	: "Program Page",
          page_url : window.location.href || "NA"
        }
      )
      updateStateSession(
        {
          parentSection : "hero_banner"
        }
      )
      setClickedInsideLeadForm(true);
    }
  };

  const handleShare = () =>{
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ShareIcon,
        modalData: { programTitle:BannerData?.Heading?.text},
      },
    });
     setTimeout(() => {
                 pushToDataLayer({
                   event: `share_initiate`,
                   cta_text: `Share`,
                   section_name: "hero_banner",
                   page_type: getGlobalStateValue("pageType"),
                   page_url: location.href,
                   header_title:BannerData?.Heading?.text,
                 });
               }, 2500);
  }

  const handleClickOutsideLeadForm = (e) => {
    const formElement = document.getElementById("new-lead-form");
    if (formElement && !formElement.contains(e.target)) {
      setClickedInsideLeadForm(false); // Reset if clicked outside
    }
  };
  // const [isCampusImmersionPage, setCampusImmersionPage] = useState(true);
  // if(title.includes("immersion")){
  //   setCampusImmersionPage(true);
  // }
    

  // Add event listener for clicks outside the open lead form
  useEffect(() => {
    document.addEventListener("click", handleClickOutsideLeadForm);
    return () => {
      document.removeEventListener("click", handleClickOutsideLeadForm);
    };
  }, []);
  const newurl = imgPathReplace(NewBannerUI?.bannerImage?.data?.attributes.url)
  return (
    <div className="container">
      <div
        className={isCampusImmersionPage ? styles.BannerImage__container__campusImmersion : styles.BannerImage__container}
        style={
          !isMobile
            ? {
                background: `url(${imgPathReplace(NewBannerUI?.bannerImage?.data?.attributes?.url)}) no-repeat`,
                backgroundPosition: "50% center",
                backgroundSize: "cover",
                
              }
            : {}
            
        }
      >
        {/* Left section with box shadow for blue */}
        <div className={cn( isCampusImmersionPage ? styles.BannerImage__leftContainer__campusImmersion 
        : styles.BannerImage__leftContainer, "text-primary-blue")} 
        
        
        style={isMobile ? { 
                background: `url(${imgPathReplace(NewBannerUI.bannerImage.data.attributes.url)}) no-repeat`,
                backgroundPosition: "50% center",
                backgroundSize: "cover"
              } : null}>
          {/* Upper subtitle and title section */}
          {/* Subtitle */}
          <div className={styles.mainContent} style={!isMobile && NewBannerUI.tagTextHTML ? { minHeight: 0}: {}}>
            {BannerData?.ProgramType?.enabled ? (
              <p style={{color:'white'}} className={cn(isCampusImmersionPage ?  styles.BannerImage__subtitle__Immersion:styles.BannerImage__subtitle, "uppercase")}>
                {BannerData?.ProgramType?.text}
              </p>
            ) : null}
            {/* Title */}
            {BannerData?.Heading?.enabled ? (
              <Markdown as="h1" className={cn(isCampusImmersionPage ? styles.BannerImage__title__campusImmersion : styles.BannerImage__title)}>
                {BannerData?.Heading?.text.replace(/^#\s+(.*)$/gm, "$1")}
              </Markdown>
            ) : null}
             {BannerData?.Duration?.enabled && (
              <div className={styles.durationWrapper}>
                <p className={cn(isCampusImmersionPage? styles.BannerImage__duration__campusImmersion : styles.BannerImage__duration,isCampusImmersionPage?"": "uppercase" )}>
                  <span className={cn(styles.BannerImage__durationLabel)}>Duration:</span>{" "}
                  {BannerData?.Duration?.text}
                </p>
              </div>
            )}
          

          {/* CTA */}
          {BannerData?.CTA?.enabled && !isMobile && (
            <>
              <div className={cn(isCampusImmersionPage ? styles.BannerImage__cta__campusImmersion : styles.BannerImage__cta)}>
              <div className='flex gap-2'>
                <CommonButton
                  onClickStorePayload={
                    {
                      sectionTitle : "Hero Banner",
                      parentSection : "hero_banner"
                    }
                  }
                  GAData={gaData}
                  GADataNew={{
                    ...GA_EVENTS.get(LEAD_INITIATE),
                    cta_text: BannerData?.CTA?.text,
                    section_name: "hero_banner",
                    header_title: BannerData?.Heading?.text || "NA",
                    isPageType: true,
                    page_url : true
                  }}
                  isEventOnly={true}
                  CTATarget="_self"
                  programTitle={BannerData?.Heading?.text}
                  type={"button"}
                  modalType={ModalTypes.DownloadBrochure}
                  scroll={false}                
                  color="#ffc907"
                  icon="/_a/icons/left-arrow-blue-down.svg"
                  hoverIcon="/_a/icons/left-arrow-blue-down.svg"
                  modalData={{ specializationText, Custom10PgType }}
                  className={styles.BannerImage__CTAStyle}
                >
                  {BannerData?.CTA?.text}
                </CommonButton>
                <div className={styles.shareIconDiv} onClick={handleShare}>
                  <img height={20} width={20} src={shareIcon.src}></img>
                </div>
                </div>
              </div>
              {isCampusImmersionPage && <div className={styles.immersion__note}>
                <p>NOTE:- Only For Students Residing In India.</p>
              </div>}
            </>
          )}
           {BannerData?.CTA?.enabled && isMobile && (
          <>
            <div className={cn(isCampusImmersionPage ? styles.BannerImage__cta__campusImmersion : styles.BannerImage__cta)} style={!NewBannerUI.tagTextHTML ?  { top: 185 } : {} }>
            <div className='flex gap-2'>
              <CommonButton
                GAData={gaData}
                CTATarget="_self"
                isEventOnly
                GADataNew={{
                  ...GA_EVENTS.get(LEAD_INITIATE),
                  cta_text: BannerData?.CTA?.text,
                  section_name: "hero_banner",
                  header_title: BannerData?.Heading?.text || "NA",
                  isPageType: true,
                  page_url : true
                }}
                onClickStorePayload={
                  {
                    parentSection : "hero_banner"
                  }
                }
                programTitle={BannerData?.Heading?.text}
                type={"button"}
                modalType={ModalTypes.DownloadBrochure}
                scroll={false}
                color="#ffcc00"
                icon="/_a/icons/left-arrow-blue-down.svg"
                hoverIcon="/_a/icons/left-arrow-blue-down.svg"
                modalData={{ specializationText, Custom10PgType }}
                className={styles.BannerImage__CTAStyle}
              >
                {BannerData?.CTA?.text}
              </CommonButton>
              <div className={styles.shareIconDiv} onClick={handleShare}>
                  <img height={20} width={20} src={shareIcon.src}></img>
                </div>
                </div>
            </div>
            {isCampusImmersionPage && <div className={styles.immersion__note}>
                <p>NOTE:- Only For Students Residing In India.</p>
              </div>}
          </>
        )}
         {isMobile && (
          <ImageTag
            htmlData={NewBannerUI.tagTextHTML}
            image={NewBannerUI.tagImage.data?.attributes?.url}
          />
        )}
           </div> 
            {/* Course duration */}
            {BannerData?.Sponsor?.enabled && (
              <div className={cn(styles.sponsor)}>
                <div>
                  <h6>{BannerData?.Sponsor?.Title}</h6>
                </div>
                <div>
                  <img
                    src={BannerData?.Sponsor?.Image?.data?.attributes?.url}
                    alt={BannerData?.Sponsor?.Image?.data?.attributes?.alternativeText}
                    loading="lazy"
                  />
                </div>
              </div>
            )}
        </div>
        {isCampusImmersionPage&& !isMobile && <div className={styles.MiddleContainer}>
          <div className={cn(styles.KeyFeatures)}>
            <div className={styles.FeatureItem}>
              <img src="https://amityonline.com/_s/key1_7398c42a9c.png" loading="lazy" alt="Campus Residency" />
              <div className={styles.headingItems}> <h3>CAMPUS RESIDENCY</h3>
                <p>Kickstart the program with 3-5 days of residency at Noida campus</p>
              </div>
            </div>
            <div className={styles.FeatureItem} style={{ paddingLeft: '30px' }}>
              <img src="https://amityonline.com/_s/key2_20301aafda.png" loading="lazy" alt="Campus Immersions" />
              <div className={styles.headingItems}>
                <h3>CAMPUS IMMERSIONS</h3>
                <p>Dive into immersive learning with 16 immersions (2-3 days each) with a choice of 10+ campuses across India</p>
              </div>
            </div>
            <div className={styles.FeatureItem}>
              <img src="https://amityonline.com/_s/key3_78c4af8efa.png" loading="lazy" alt="Networking Opportunities" />
              <div className={styles.headingItems}>
                <h3>NETWORKING OPPORTUNITIES</h3>
                <p>Exchange knowledge and connect with like-minded seasoned professionals with minimum 3 years of experience</p>
              </div>
            </div>
          </div>
        </div>}

        {/* Right section with image */}
        <div id="new-lead-form" className={`${styles.leadFormWrapper} ${styles.leadFormWrapperImmersion} `} onClick={handleClickInsideLeadForm}>
          <OTPContextProvider>
            <OTPContext.Consumer>
              {({ isHeaderHidden }) => (
                <>
                  {!isHeaderHidden && (
                    <Markdown as="h2" className={styles.formHeading} >
                      Apply Now
                    </Markdown>
                  )}
                  <OTPContextWrapper>
                    <ProgramDetailsConnectModalForm
                      ProgramId={ProgramId}
                      associatedPrograms={associatedPrograms}
                      isNewLeadForm={true}
                      NewBannerUI={NewBannerUI}
                      isMobile={isMobile}
                      setLeadFailed={isLeadFailed}
                      isSeatsFilledEnabled ={isSeatsFilledEnabled}
                      Numbers ={Numbers}
                    />
                  </OTPContextWrapper>
                </>
              )}
            </OTPContext.Consumer>
          </OTPContextProvider>
          
        </div>

        {isCampusImmersionPage&& isMobile && <div className={styles.MiddleContainer}>
          
            <div className={styles.FeatureItem}>
              <img src="https://amityonline.com/_s/key1_7398c42a9c.png" loading="lazy" alt="Campus Residency" />
              <div className={styles.headingItems}> <h3>CAMPUS RESIDENCY</h3>
                <p>Kickstart the program with 3-5 days of residency at Noida campus</p>
              </div>
            </div>
            <div className={styles.FeatureItem}>
              <img src="https://amityonline.com/_s/key2_20301aafda.png" loading="lazy" alt="Campus Immersions" />
              <div className={styles.headingItems}>
                <h3>CAMPUS IMMERSIONS</h3>
                <p>Dive into immersive learning with 16 immersions (2-3 days each) with a choice of 10+ campuses across India</p>
              </div>
            </div>
            <div className={styles.FeatureItem}>
              <img src="https://amityonline.com/_s/key3_78c4af8efa.png" loading="lazy" alt="Networking Opportunities" />
              <div className={styles.headingItems}>
                <h3>NETWORKING OPPORTUNITIES</h3>
                <p>Exchange knowledge and connect with like-minded seasoned professionals with minimum 3 years of experience</p>
              </div>
            </div>
         
        </div>}


        {!isMobile && (
          <ImageTag
            htmlData={NewBannerUI.tagTextHTML}
            image={NewBannerUI.tagImage.data?.attributes?.url}
          />
        )}
      </div>
      <div className={styles.imgWrapper} style={{ position: "relative" }}>
      </div>
    </div>
  );
}
